import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';
import ar from './locales/ar.json';
import sw from './locales/sw.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, fr: { translation: fr }, pt: { translation: pt }, ar: { translation: ar }, sw: { translation: sw } },
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: { order: ['localStorage', 'navigator'], caches: ['localStorage'] },
  });

export const LANGUAGES = [
  { code: 'en', name: 'English', flag: 'GB' },
  { code: 'fr', name: 'Fran\u00e7ais', flag: 'FR' },
  { code: 'pt', name: 'Portugu\u00eas', flag: 'PT' },
  { code: 'ar', name: '\u0627\u0644\u0639\u0631\u0628\u064a\u0629', flag: 'SA', rtl: true },
  { code: 'sw', name: 'Kiswahili', flag: 'KE' },
];

export default i18n;
